import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.review.survey');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-review-survey',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.review.survey/view.scss */
:host {
  display: block;
  min-height: 100%;
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #202124;
}

.review-survey-viewer {
  min-height: 100%;
  background: #f5f5f6;
}

.review-survey-viewer__shell {
  width: min(100% - 36px, 1180px);
  margin-inline: auto;
}

.review-survey-viewer__header {
  background: #ffffff;
}

.review-survey-viewer__header .review-survey-viewer__shell {
  padding-block: 22px 28px;
}

.review-survey-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 38px;
  padding: 0 12px;
  color: #55565d;
  background: #f0f0f1;
  box-shadow: none !important;
  cursor: pointer;
}

.review-survey-back:hover {
  color: #202124;
  background: #e6e6e8;
}

.review-survey-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 36px;
  margin-top: 24px;
}

.review-survey-heading p,
.section-kicker {
  margin: 0;
  color: #c9532f;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.review-survey-heading h1 {
  margin: 8px 0 0;
}

.review-survey-heading > div > span {
  display: block;
  margin-top: 8px;
  color: #777880;
  font-size: 12px;
}

.review-survey-heading dl {
  display: grid;
  grid-template-columns: repeat(4, minmax(72px, 1fr));
  gap: 22px;
  margin: 0;
}

.review-survey-heading dt {
  color: #94959c;
  font-size: 12px;
  font-weight: 700;
}

.review-survey-heading dd {
  margin: 5px 0 0;
  color: #34353a;
  font-size: 12px;
  font-weight: 700;
}

.review-survey-viewer > main {
  display: grid;
  gap: 12px;
  padding-block: 22px 42px;
}

.review-survey-intro,
.review-survey-section,
.review-survey-footer {
  background: #ffffff;
}

.review-survey-intro {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  padding: 24px 26px;
}

.review-survey-intro h2 {
  margin: 7px 0 0;
  color: #292a2e;
  font-size: 18px;
  font-weight: 700;
}

.review-survey-intro p:not(.section-kicker) {
  max-width: 720px;
  margin: 7px 0 0;
  color: #777880;
  font-size: 12px;
  line-height: 1.65;
}

.review-survey-intro__meta {
  flex: 0 0 auto;
  padding: 14px 16px;
  background: #f5f5f6;
}

.review-survey-intro__meta span,
.review-survey-intro__meta strong {
  display: block;
}

.review-survey-intro__meta span {
  color: #94959c;
  font-size: 12px;
  font-weight: 700;
}

.review-survey-intro__meta strong {
  margin-top: 5px;
  color: #34353a;
  font-size: 12px;
}

.review-survey-section > header {
  display: flex;
  align-items: flex-start;
  gap: 13px;
  padding: 20px 24px;
  background: #fafafa;
}

.review-survey-section > header > span {
  display: grid;
  width: 30px;
  height: 30px;
  place-items: center;
  flex: 0 0 auto;
  color: #ffffff;
  background: #303136;
  font-size: 12px;
  font-weight: 700;
}

.review-survey-section h2,
.review-survey-section h3,
.review-survey-section p {
  margin: 0;
}

.review-survey-section h2 {
  color: #292a2e;
  font-size: 13px;
  font-weight: 700;
}

.review-survey-section header p {
  margin-top: 5px;
  color: #85868d;
  font-size: 12px;
}

.review-survey-decisions {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding: 18px 24px 22px;
}

.review-survey-decisions article {
  display: flex;
  min-height: 74px;
  align-items: center;
  gap: 12px;
  padding: 14px;
  background: #f5f5f6;
}

.review-survey-decisions i {
  color: #66676e;
  font-size: 16px;
}

.review-survey-decisions strong {
  color: #38393e;
  font-size: 12px;
}

.review-survey-decisions p {
  margin-top: 4px;
  color: #85868d;
  font-size: 12px;
}

.review-survey-questions {
  display: grid;
  gap: 5px;
  padding: 8px;
  background: #f5f5f6;
}

.review-survey-questions article {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  align-items: center;
  gap: 24px;
  min-height: 82px;
  padding: 14px 16px;
  background: #ffffff;
}

.review-survey-question__copy {
  display: flex;
  align-items: flex-start;
  gap: 11px;
}

.review-survey-question__copy em {
  display: grid;
  width: 24px;
  height: 24px;
  place-items: center;
  flex: 0 0 auto;
  color: #ffffff;
  background: #55565d;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.review-survey-question__copy h3 {
  color: #34353a;
  font-size: 12px;
  font-weight: 700;
}

.review-survey-question__copy p {
  margin-top: 5px;
  color: #85868d;
  font-size: 12px;
  line-height: 1.5;
}

.review-survey-scale {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 5px;
}

.review-survey-scale span {
  display: grid;
  min-height: 40px;
  place-items: center;
  align-content: center;
  color: #66676e;
  background: #f1f1f2;
}

.review-survey-scale strong {
  font-size: 12px;
}

.review-survey-scale small {
  min-height: 8px;
  margin-top: 2px;
  font-size: 12px;
}

.review-survey-issues {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
  padding: 18px 24px 22px;
}

.review-survey-issues span {
  display: flex;
  min-height: 40px;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  color: #5f6067;
  background: #f5f5f6;
  font-size: 12px;
  font-weight: 700;
}

.review-survey-notes {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  padding: 18px 24px 22px;
}

.review-survey-notes article {
  padding: 16px;
  background: #f5f5f6;
}

.review-survey-notes h3 {
  color: #34353a;
  font-size: 12px;
  font-weight: 700;
}

.review-survey-notes p {
  margin-top: 5px;
  color: #85868d;
  font-size: 12px;
}

.review-survey-notes article > div {
  min-height: 74px;
  margin-top: 12px;
  padding: 12px;
  color: #aaaab0;
  background: #ffffff;
  font-size: 12px;
}

.review-survey-footer {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 17px 20px;
  color: #777880;
}

.review-survey-footer i {
  color: #c9532f;
}

.review-survey-footer p {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
}

@media (max-width: 900px) {
  .review-survey-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .review-survey-heading dl {
    width: 100%;
  }
  .review-survey-questions article {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 620px) {
  .review-survey-viewer__shell {
    width: min(100% - 24px, 1180px);
  }
  .review-survey-heading dl,
  .review-survey-decisions,
  .review-survey-issues,
  .review-survey-notes {
    grid-template-columns: 1fr;
  }
  .review-survey-intro {
    align-items: flex-start;
    flex-direction: column;
  }
}
/* 11: workspace information hierarchy and shared component roles. */
:host-context(.reviewops-shell) .review-survey-viewer .review-survey-viewer__shell {
  max-width: 1100px;
  margin: 0 auto;
  padding: 24px var(--ro-gutter) 48px;
}
:host-context(.reviewops-shell) .review-survey-viewer .review-survey-section {
  padding: 24px;
  margin-bottom: 24px;
}
@media (max-width: 639px) {
  :host-context(.reviewops-shell) .review-survey-viewer .review-survey-section {
    padding: 16px;
  }
}`],
})
export class PageReviewSurveyComponent implements OnInit {
    public kind: 'qa' | 'kg' = 'qa';
    public taskId: string = '';
    public task: any = {};
    public loading: boolean = true;
    public scoreOptions: number[] = [1, 2, 3, 4, 5];
    public dimensions: any[] = [
        { label: '질문 적절성', question: '질문의 대상과 요구사항이 명확하고 원문으로 답할 수 있습니까?' },
        { label: '답변 정확성', question: '답변의 내용과 핵심 사실이 원문과 정확히 일치합니까?' },
        { label: '근거 적절성', question: '제시된 근거가 답변의 핵심 내용을 직접적이고 충분하게 뒷받침합니까?' },
        { label: 'QA 구성 일치성', question: '질문·답변·근거·분류 라벨이 서로 자연스럽고 일관되게 연결됩니까?' },
        { label: '표현·형식 완결성', question: '중복이나 모호한 표현 없이 문장과 형식이 완결되어 있습니까?' },
        { label: '종합 활용성', question: '전체적으로 수정 없이 사용할 수 있는 QA 품질입니까?' }
    ];
    public decisions: any[] = [
        { label: '사용 가능', description: '현재 결과를 유지합니다.', icon: 'fa-solid fa-circle-check' },
        { label: '수정 필요', description: '보완 후 다시 확인합니다.', icon: 'fa-solid fa-pen-to-square' },
        { label: '사용 제외', description: '결과에서 제외합니다.', icon: 'fa-solid fa-circle-xmark' }
    ];
    public issues: string[] = ['사실 오류', '근거 부족', '맥락 누락', '유형·관계 오류', '중복', '표현 개선'];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        try {
            await this.service.init();
            this.kind = WizRoute.segment.kind === 'kg' ? 'kg' : 'qa';
            this.taskId = WizRoute.segment.taskId || '';
            const loaded = await this.loadWorkspaceTask();
            if (!loaded) this.loadTask();
            if (!this.task || !this.task.id) {
                await this.service.modal.warning('요청한 검수 설문지를 찾을 수 없습니다.', false, '확인');
                this.service.href(this.kind === 'kg' ? '/kg-reviews' : '/human-reviews');
                return;
            }
            await this.service.render();
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    private normalizeWorkspaceState(payload: any) {
        const candidates = [
            payload?.data?.data?.state,
            payload?.data?.state,
            payload?.data?.data,
            payload?.result?.state,
            payload?.state,
            payload?.result,
            payload?.data,
            payload
        ];
        const state = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && (
                Object.prototype.hasOwnProperty.call(candidate, 'schema_version')
                || Object.prototype.hasOwnProperty.call(candidate, 'projects')
                || Object.prototype.hasOwnProperty.call(candidate, 'surveys')
                || Object.prototype.hasOwnProperty.call(candidate, 'harnesses')
                || Object.prototype.hasOwnProperty.call(candidate, 'tasks')
                || Object.prototype.hasOwnProperty.call(candidate, 'evaluations')
            ));
        if (!state) return null;
        const rows = (value: any) => Array.isArray(value)
            ? value
            : (value && typeof value === 'object' ? Object.values(value) : []);
        return Object.assign({}, state, {
            projects: rows(state.projects),
            surveys: rows(state.surveys),
            harnesses: rows(state.harnesses),
            tasks: rows(state.tasks),
            evaluations: state.evaluations && typeof state.evaluations === 'object' && !Array.isArray(state.evaluations)
                ? state.evaluations
                : {}
        });
    }

    private async loadWorkspaceTask() {
        try {
            const response = await fetch('/api/v1/review-workspace/state', {
                method: 'GET',
                headers: { Accept: 'application/json' },
                credentials: 'same-origin',
                cache: 'no-store'
            });
            if (!response.ok) throw new Error('REVIEW_WORKSPACE_STATE_UNAVAILABLE');
            const payload = await response.json();
            const state = this.normalizeWorkspaceState(payload);
            if (!state || !Array.isArray(state.tasks)) throw new Error('REVIEW_WORKSPACE_STATE_INVALID');

            const source = state.tasks.find((item: any) => {
                return String(item && item.id || '') === this.taskId
                    && String(item && item.kind || '').toLowerCase() === this.kind;
            });
            if (!source) {
                this.task = {};
                this.dimensions = [];
                return true;
            }

            const projects = Array.isArray(state.projects) ? state.projects : [];
            const surveys = Array.isArray(state.surveys) ? state.surveys : [];
            this.task = this.normalizeWorkspaceTask(source, projects, surveys);
            this.dimensions = this.workspaceDimensions(source, surveys);
            return true;
        } catch (error) {
            return false;
        }
    }

    private normalizeWorkspaceTask(task: any, projects: any[], surveys: any[]) {
        const projectId = String(task.projectId || task.project_id || '');
        const project = projects.find((item: any) => String(item && (item.id || item.projectId || item.project_id) || '') === projectId) || {};
        const snapshot = task && (task.survey_snapshot || task.surveySnapshot) || {};
        const surveyId = String(task.surveyId || task.survey_id || snapshot.id || '');
        const survey = surveys.find((item: any) => String(item && item.id || '') === surveyId) || {};
        const samples = Array.isArray(task.samples) ? task.samples : [];
        const projectName = typeof task.project === 'string' && task.project.trim()
            ? task.project
            : String(task.projectName || task.project_name || project.name || project.title || projectId || '검수 프로젝트');
        return Object.assign({}, task, {
            id: String(task.id || ''),
            title: String(task.title || task.dataset || (this.kind === 'kg' ? 'KG 대표 표본 검수' : 'QA 대표 표본 검수')),
            project: projectName,
            survey: String(task.survey || task.surveyName || task.survey_name || snapshot.name || survey.name || survey.title || '검수 설문지'),
            version: String(task.surveyVersion || task.survey_version || snapshot.version || survey.activeVersion || survey.active_version || survey.version || 'v1.0'),
            reviewer: String(task.reviewer || task.assignee || task.assigneeName || task.assignee_name || '검수 담당자'),
            sampleCount: Number(task.total ?? task.sampleCount ?? task.sample_count ?? samples.length) || samples.length,
            questionCount: this.workspaceDimensions(task, surveys).length,
            due: this.dateLabel(task.due || task.dueAt || task.due_at)
        });
    }

    private workspaceDimensions(task: any, surveys: any[]) {
        const snapshot = task && (task.survey_snapshot || task.surveySnapshot) || {};
        const surveyId = String(task && (task.surveyId || task.survey_id) || snapshot.id || '');
        const survey = surveys.find((item: any) => String(item && item.id || '') === surveyId) || {};
        const activeVersion = String(task && (task.surveyVersion || task.survey_version) || snapshot.version || survey.activeVersion || survey.active_version || '');
        const versions = Array.isArray(survey.versions) ? survey.versions : [];
        const version = versions.find((item: any) => item && (item.active === true || String(item.version || item.id || '') === activeVersion)) || {};
        const rows = Array.isArray(snapshot.dimensions)
            ? snapshot.dimensions
            : (Array.isArray(version.dimensions) ? version.dimensions : (Array.isArray(survey.dimensions) ? survey.dimensions : []));
        return rows.map((dimension: any, index: number) => ({
            key: String(dimension && (dimension.key || dimension.id) || 'dimension_' + (index + 1)),
            label: String(dimension && (dimension.label || dimension.name) || '평가 항목 ' + (index + 1)),
            question: String(dimension && (dimension.question || dimension.description) || '이 항목의 품질을 평가해주세요.')
        }));
    }

    private dateLabel(value: any) {
        if (!value) return '—';
        const text = String(value);
        const match = text.match(/^(\d{4})[-.](\d{2})[-.](\d{2})/);
        return match ? [match[1], match[2], match[3]].join('.') : text;
    }

    public kindLabel() {
        return this.kind === 'kg' ? 'KG 검수' : 'QA 검수';
    }

    public backToReview() {
        const base = this.kind === 'kg' ? '/kg-reviews' : '/human-reviews';
        this.service.href(base + '?view=detail&task=' + encodeURIComponent(this.task.id || this.taskId));
    }

    private loadTask() {
        const tasks: any = {
            'QA-RV-2026-017-R01': {
                id: 'QA-RV-2026-017-R01',
                title: '동북아 역사 QA 대표 표본 1회차',
                project: '동북아 역사 사료 QA 구축',
                survey: '동북아 역사 QA 대표 표본 검수서 v1.0',
                version: 'v1.0',
                reviewer: '김보미',
                sampleCount: 8,
                questionCount: 13,
                due: '2026.08.29'
            },
            'QA-RV-2026-018-R01': {
                id: 'QA-RV-2026-018-R01',
                title: '근현대 인물 QA 대표 표본 1회차',
                project: '근현대 인물 관계 QA',
                survey: '역사 QA 정확성 검수서 v1.0',
                version: 'v1.0',
                reviewer: '박서연',
                sampleCount: 6,
                questionCount: 13,
                due: '2026.08.30'
            },
            'QA-RV-2026-019-R02': {
                id: 'QA-RV-2026-019-R02',
                title: '독도 사료 QA 대표 표본 2회차',
                project: '독도 사료 질의응답 검수',
                survey: '동북아 역사 QA 대표 표본 검수서 v1.0',
                version: 'v1.0',
                reviewer: '김보미',
                sampleCount: 5,
                questionCount: 13,
                due: '2026.08.27'
            },
            'KG-RV-2026-017-R01': {
                id: 'KG-RV-2026-017-R01',
                title: '동북아 역사 KG 대표 표본 1회차',
                project: '동북아 역사 지식그래프 구축',
                survey: '동북아 역사 KG 대표 표본 검수서 v1.0',
                version: 'v1.0',
                reviewer: '김보미',
                sampleCount: 6,
                questionCount: 13,
                due: '2026.08.29'
            },
            'KG-RV-2026-019-R01': {
                id: 'KG-RV-2026-019-R01',
                title: '독도 사료 KG 대표 표본 1회차',
                project: '독도 사료 지식그래프',
                survey: '역사 지식그래프 관계 검수서 v1.0',
                version: 'v1.0',
                reviewer: '박서연',
                sampleCount: 4,
                questionCount: 13,
                due: '2026.08.31'
            }
        };
        this.task = tasks[this.taskId] || tasks[this.kind === 'kg' ? 'KG-RV-2026-017-R01' : 'QA-RV-2026-017-R01'];
    }
}

export default PageReviewSurveyComponent;